import learningApi from '@src/services/api/learning/index'

export default learningApi.defineApi([
  // トークン発行
  {
    name: 'getToken',
    method: 'post',
    url: '/token/user'
  }
  // トークン更新（これ直読みだから使う？
  // {
  //   name: 'refreshToken',
  //   method: 'patch',
  //   url: '/token'
  // }
])
